import { render, staticRenderFns } from "./addGreement.vue?vue&type=template&id=4473ab24&scoped=true&"
import script from "./addGreement.vue?vue&type=script&lang=js&"
export * from "./addGreement.vue?vue&type=script&lang=js&"
import style0 from "./addGreement.vue?vue&type=style&index=0&id=4473ab24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473ab24",
  null
  
)

export default component.exports